import { Component, OnInit } from '@angular/core';
import { AsyncPipe } from '@angular/common';
import {MatProgressSpinnerModule, ProgressSpinnerMode} from '@angular/material/progress-spinner';
import { PmuService } from '../../services/data/pmu.service';
import { TranslateModule } from '@ngx-translate/core';
import { distinctUntilChanged, Subscription } from 'rxjs';
import { ActionBtn } from '../../models/overlay-loader.model';

@Component({
  selector: 'app-loading-overlay',
  imports: [MatProgressSpinnerModule, AsyncPipe, TranslateModule],
  templateUrl: './loading-overlay.component.html',
  styleUrl: './loading-overlay.component.scss'
})
export class LoadingOverlayComponent implements OnInit {
  loadingMsg!: string;
  showSpinner!: boolean;
  actionBtns!: ActionBtn[];
  subscriptions: Subscription = new Subscription();
  constructor(private readonly pmuService: PmuService) {}
  ngOnInit(): void {
    this.subscriptions.add(
      this.pmuService.overLayOptions$.pipe(distinctUntilChanged()).subscribe(opt => {
        this.loadingMsg = opt.msg ?? "";
        this.showSpinner = opt.spinner ?? false;
        this.actionBtns = opt.actions ?? [];
      })
    )
  }
  get showOverlay() {
    return this.pmuService.overLayLoader$.asObservable();
  }
  spinnerProps = {
    mode: 'indeterminate',
    color: 'primary',
    diameter: 200,
    strokeWidth: 4,
    value: '',
    width: 200,
    height: 200
  }
  get spinnerMode(): ProgressSpinnerMode {
    return this.spinnerProps.mode as ProgressSpinnerMode;
  }
}
